module.exports = __webpack_public_path__ + "img/x9.7be16cf3.jpg";